import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51221f61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row p-4 border-t border-gray-200 bg-white" }
const _hoisted_2 = {
  class: "relative ml-auto z-0 inline-flex rounded-md shadow-sm -space-x-px",
  "aria-label": "Pagination"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1))
const _hoisted_4 = { class: "h-5 w-5 text-center" }
const _hoisted_5 = {
  key: 0,
  class: "relative w-10 h-10 py-2 inline-block items-center cursor-pointer border text-sm text-center font-medium"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))
const _hoisted_8 = { class: "h-5 w-5 text-center" }

import { computed, ref, watch } from "vue";
import type { PropType } from "vue";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationV2',
  props: {
  config: {
    type: Object as PropType<{
      page: number;
      dataLength: number;
      count: number;
      pageCount: number;
      rowsPerPage: number;
      isEmitOnClick?: Boolean;
    }>,
    default: {},
  },
  isLagacy: Boolean,
},
  emits: ["update:config", "changePage"],
  setup(__props, { emit }) {

const props = __props

const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const SelectorIcon = require("@heroicons/vue/solid/SelectorIcon");
const route = useRoute();
const rowsPerPageOptions = [2, 5, 10, 20, 30, 40];
const configSync = computed({
  get: () => props.config,
  set: (value) => emit("update:config", value),
});
const pageInput = ref(configSync.value.page);

const pageRange = computed(() => {
  const { page, count, rowsPerPage } = configSync.value;
  const currentRange = page * rowsPerPage;
  return {
    from: currentRange - rowsPerPage + 1,
    to: currentRange > count ? count : currentRange,
  };
});
const rowsPerPageSync = computed({
  get: () => props.config?.rowsPerPage,
  set: (value) =>
    emit("update:config", { ...props.config, rowsPerPage: value }),
});

const onPageConfig = () => {
  emit("update:config", { ...configSync.value, page: pageInput.value || 1 });
};
const setPage = (method: string) => {
  let page =
    method === "next"
      ? Number(configSync.value.page) + 1
      : Number(configSync.value.page) - 1
      ;
  if (page < 1) {
    page = 1;
  }
  // if (page > props.config.pageCount) { page = props.config.pageCount }

  // if(!configSync.value.dataLength && configSync.value.count < configSync.value.rowsPerPage){
  //   return
  // }
  if (
    method === "next" &&
    configSync.value.dataLength < configSync.value.rowsPerPage
  ) {
    return;
  }
  if (props.config.isEmitOnClick) {
    emit("update:config", { ...props.config, page });
  }

  if (page > 0) emit("update:config", { ...props.config, page });
  pageInput.value = page;
};

const onKeyup = (e: any) => {
  e.preventDefault();
  const input = e?.target?.value;
  if (
    (e.code == "Enter" || e.code == "NumpadEnter" || e.keyCode == 13) &&
    input > 0
  ) {
    configSync.value.page = input;
  }
};

watch(configSync, (val) => {
  if (val.page === 1) {
    pageInput.value = 1;
  }
});




return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (setPage('previous'))),
        class: "relative inline-flex items-center w-10 h-10 px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
      }, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            class: "text-gray-500",
            icon: ['fas', 'chevron-left'],
            transform: "shrink-2"
          })
        ])
      ]),
      (__props.config.isEmitOnClick)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.config.page), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pageInput).value = $event)),
              min: "1",
              class: "w-14 h-10 text-center border border-gray-300 focus:outline-none focus:ring-white",
              onKeyup: onKeyup
            }, null, 544), [
              [_vModelText, pageInput.value]
            ])
          ])),
      _createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (setPage('next'))),
        class: "relative cursor-pointer inline-flex items-center w-10 h-10 px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
      }, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_font_awesome_icon, {
            class: "text-gray-500",
            icon: ['fas', 'chevron-right'],
            transform: "shrink-2"
          })
        ])
      ])
    ])
  ]))
}
}

})